import { defineComponent, computed, openBlock, createElementBlock, createTextVNode, createElementVNode, toDisplayString } from "vue";
const _hoisted_1 = {
  class: "product-insight__message"
};
const _hoisted_2 = {
  class: "product-insight__message--amount"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxShopperInsights",
  props: {
    actionType: {},
    adjustmentType: {
      default: ""
    },
    amount: {},
    rangeType: {},
    styleId: {}
  },
  setup(__props) {
    const props = __props;
    const computedAction = computed(() => {
      const actionMessages = {
        PURCHASE: "people purchased",
        CART: "people added to cart"
      };
      return `${actionMessages[props.actionType] || "views"} this week.`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = createTextVNode(" Great choice! ")), createElementVNode("span", _hoisted_2, toDisplayString(_ctx.amount), 1), createTextVNode(" " + toDisplayString(computedAction.value), 1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxShopperInsights2.mjs.map
